import Title from './Title';
export { instanceOfTitleMargin } from './utils';
export * from './Title';
export default Title;
